export const charData = [
    {
        level: "1_1",
        chars: ["山", "高", "的", "人", "個", "大", "上", "下", "在", "有", "手", 
        "很", "隻", "小", "孩", "家", "也", "我", "指", "五"]
    },
    {
        level: "1_2",
        chars: ["兩", "十", "來", "是", "女", "媽", "爸", "馬", "朋", "友", "去", 
        "這", "不", "你", "們", "鳥", "天", "地", "花", "朵"]
    },
    {
        level: "1_3",
        chars: ["四", "草", "到", "說", "好", "什", "麼", "飛", "看", "裡", "起", 
        "要", "男", "明", "兔", "白", "書", "本", "會", "吃"]
    },
    {
        level: "1_4",
        chars: ["和", "水", "幾", "沒", "走", "都", "出", "回", "了", "太", "他", 
        "嗎", "長", "愛", "喝", "可", "想", "見", "給", "玩"]
    },
    {
        level: "1_5",
        chars: ["就", "把", "樹", "頭", "耳", "快", "得", "子", "多", "又", "妹", 
        "雨", "誰", "門", "貓", "開", "老", "紅", "邊", "那"]
    },
    {
        level: "2_1",
        chars: ["只", "住", "笑", "著", "過", "她", "自", "己", "風", "還", "對", "跑", "真", "氣", "心", "雲", "羊", "果", "聽", "呀"]
    },
    {
        level: "2_2",
        chars: ["叫", "青", "像", "陽", "唱", "歌", "能", "雞", "跳", "兒", "樣", "色", "身", "吧", "聲", "魚", "後", "弟", "片", "哥"]
    },
    {
        level: "2_3",
        chars: ["葉", "姐", "為", "狗", "面", "搖", "問", "呢", "中", "前", "進", "東", "河", "空", "做", "西", "用", "力", "從", "口"]
    },
    {
        level: "2_4",
        chars: ["早", "公", "找", "路", "美", "晚", "星", "坐", "請", "園", "興", "最", "知", "到", "學", "比", "春", "點", "綠", "國"]
    },
    {
        level: "2_5",
        chars: ["以", "方", "洗", "亮", "月", "圓", "黃", "旗", "今", "哭", "別", "火", "照", "怕", "師", "放", "光", "時", "生", "日"]
    },
    {
        level: "3_1",
        chars: ["樂", "蝴", "蝶", "麗", "蟲", "輕", "讓", "蛙", "田", "游", "爬", "忙", "黑", "條", "毛", "成", "臉", "橋", "木", "車"]
    },
    {
        level: "3_2",
        chars: ["牛", "奶", "工", "農", "外", "帶", "候", "打", "燕", "石", "船", "動", "喜", "歡", "香", "更", "鴨", "腳", "幫", "屋"]
    },
    {
        level: "3_3",
        chars: ["每", "間", "哪", "尾", "巴", "話", "娃", "漂", "畫", "房", "怎", "鼠", "桌", "向", "嘴", "數", "閃", "海", "睡", "被"]
    },
    {
        level: "3_4",
        chars: ["拉", "站", "藍", "正", "啊", "金", "然", "滿", "才", "塊", "肉", "跟", "謝", "沙", "窗", "親", "啦", "應", "該", "雪"]
    },
    {
        level: "3_5",
        chars: ["眼", "睛", "現", "越", "常", "衣", "穿", "如", "新", "冬", "落", "變", "發", "望", "趕", "事", "洞", "婆", "覺", "年"]
    },
    {
        level: "4_1",
        chars: ["姑", "娘", "字", "寫", "故", "烏", "鴉", "傘", "件", "悄", "經", "群", "飄", "瓜", "掉", "遠", "認", "半", "張", "等"]
    },
    {
        level: "4_2",
        chars: ["伯", "原", "追", "林", "菜", "壞", "種", "肚", "病", "飯", "全", "舞", "拍", "傷", "機", "吿", "訴", "因", "所", "停"]
    },
    {
        level: "4_3",
        chars: ["電", "買", "慢", "教", "送", "旁", "急", "再", "先", "直", "答", "蜜", "蜂", "採", "許", "連", "夜", "希", "搬", "當"]
    },
    {
        level: "4_4",
        chars: ["雀", "枝", "吹", "彎", "座", "分", "定", "刀", "拿", "桌", "咬", "豬", "狼", "牙", "流", "安", "哈", "猴", "非", "桃"]
    },
    {
        level: "4_5",
        chars: ["秋", "冷", "梨", "鞋", "背", "包", "記", "行", "救", "次", "讀", "終", "於", "處", "晴", "久", "蛋", "母", "米", "物"]
    },
    {
        level: "5_1",
        chars: ["校", "同", "運", "場", "班", "筆", "名", "球", "汗", "螞", "蟻", "累", "服", "少", "午", "音", "期", "游", "戲", "奇"]
    },
    {
        level: "5_2",
        chars: ["怪", "拾", "熱", "短", "作", "假", "節", "父", "禮", "祖", "雙", "掃", "叔", "抱", "勤", "感", "已", "相", "夏", "泳"]
    },
    {
        level: "5_3",
        chars: ["姨", "表", "功", "燈", "昨", "關", "難", "結", "甜", "市", "街", "些", "城", "醫", "村", "清", "院", "潔", "鬧", "店"]
    },
    {
        level: "5_4",
        chars: ["低", "滾", "合", "除", "左", "抹", "椅", "右", "推", "勞", "曬", "醒", "危", "險", "紙", "離", "信", "重", "近", "各"]
    },
    {
        level: "5_5",
        chars: ["平", "餓", "糖", "粒", "刷", "痛", "皮", "血", "踢", "破", "伸", "忽", "死", "抓", "極", "味", "藏", "苦", "握", "歲"]
    },
    {
        level: "all",
        chars: ["山", "高", "的", "人", "個", "大", "上", "下", "在", "有", "手", 
        "很", "隻", "小", "孩", "家", "也", "我", "指", "五", "兩", "十", "來", "是", "女", "媽", "爸", "馬", "朋", "友", "去", "這", "不", "你", "們", "鳥", "天", "地", "花", "朵", "四", "草", "到", "說", "好", "什", "麼", "飛", "看", "裡", "起", 
        "要", "男", "明", "兔", "白", "書", "本", "會", "吃","和", "水", "幾", "沒", "走", "都", "出", "回", "了", "太", "他", "嗎", "長", "愛", "喝", "可", "想", "見", "給", "玩", "就", "把", "樹", "頭", "耳", "快", "得", "子", "多", "又", "妹", 
        "雨", "誰", "門", "貓", "開", "老", "紅", "邊", "那", "只", "住", "笑", "著", "過", "她", "自", "己", "風", "還", "對", "跑", "真", "氣", "心", "雲", "羊", "果", "聽", "呀", "叫", "青", "像", "陽", "唱", "歌", "能", "雞", "跳", "兒", "樣", "色", "身", "吧", "聲", "魚", "後", "弟", "片", "哥", "葉", "姐", "為", "狗", "面", "搖", "問", "呢", "中", "前", "進", "東", "河", "空", "做", "西", "用", "力", "從", "口", "早", "公", "找", "路", "美", "晚", "星", "坐", "請", "園", "興", "最", "知", "到", "學", "比", "春", "點", "綠", "國", "以", "方", "洗", "亮", "月", "圓", "黃", "旗", "今", "哭", "別", "火", "照", "怕", "師", "放", "光", "時", "生", "日", "樂", "蝴", "蝶", "麗", "蟲", "輕", "讓", "蛙", "田", "游", "爬", "忙", "黑", "條", "毛", "成", "臉", "橋", "木", "車", "牛", "奶", "工", "農", "外", "帶", "候", "打", "燕", "石", "船", "動", "喜", "歡", "香", "更", "鴨", "腳", "幫", "屋", "每", "間", "哪", "尾", "巴", "話", "娃", "漂", "畫", "房", "怎", "鼠", "桌", "向", "嘴", "數", "閃", "海", "睡", "被", "拉", "站", "藍", "正", "啊", "金", "然", "滿", "才", "塊", "肉", "跟", "謝", "沙", "窗", "親", "啦", "應", "該", "雪", "眼", "睛", "現", "越", "常", "衣", "穿", "如", "新", "冬", "落", "變", "發", "望", "趕", "事", "洞", "婆", "覺", "年", "姑", "娘", "字", "寫", "故", "烏", "鴉", "傘", "件", "悄", "經", "群", "飄", "瓜", "掉", "遠", "認", "半", "張", "等", "伯", "原", "追", "林", "菜", "壞", "種", "肚", "病", "飯", "全", "舞", "拍", "傷", "機", "吿", "訴", "因", "所", "停", "電", "買", "慢", "教", "送", "旁", "急", "再", "先", "直", "答", "蜜", "蜂", "採", "許", "連", "夜", "希", "搬", "當", "雀", "枝", "吹", "彎", "座", "分", "定", "刀", "拿", "桌", "咬", "豬", "狼", "牙", "流", "安", "哈", "猴", "非", "桃", "秋", "冷", "梨", "鞋", "背", "包", "記", "行", "救", "次", "讀", "終", "於", "處", "晴", "久", "蛋", "母", "米", "物", "校", "同", "運", "場", "班", "筆", "名", "球", "汗", "螞", "蟻", "累", "服", "少", "午", "音", "期", "游", "戲", "奇", "怪", "拾", "熱", "短", "作", "假", "節", "父", "禮", "祖", "雙", "掃", "叔", "抱", "勤", "感", "已", "相", "夏", "泳", "姨", "表", "功", "燈", "昨", "關", "難", "結", "甜", "市", "街", "些", "城", "醫", "村", "清", "院", "潔", "鬧", "店", "低", "滾", "合", "除", "左", "抹", "椅", "右", "推", "勞", "曬", "醒", "危", "險", "紙", "離", "信", "重", "近", "各", "平", "餓", "糖", "粒", "刷", "痛", "皮", "血", "踢", "破", "伸", "忽", "死", "抓", "極", "味", "藏", "苦", "握", "歲"]
    }
]